import { defineMessages } from 'react-intl'

const scope = `procurify.modules.spending-cards.components.ActiveCardholderAccountRequiredModal`

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Active cardholder account required',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: `In order to request new virtual spending cards, you'll need to set up a cardholder account.`,
  },
  setupButton: {
    id: `${scope}.setupButton`,
    defaultMessage: 'Set up account',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  requestButton: {
    id: `${scope}.requestButton`,
    defaultMessage: 'Request a card for someone else',
  },
})
